/* eslint-disable import/prefer-default-export */

export function isImageLoaded(element) {
  return element.complete && element.naturalHeight !== 0;
}



// WEBPACK FOOTER //
// ./lib/utils/image_utility.js